import { App } from './app';
import './index.css';

// Initialize the application
document.addEventListener('DOMContentLoaded', () => {
  App.create();
});